import React from 'react';
import './Header.css';


const Header = () => {
  return (
    <div className="blog-header" style={{ backgroundImage: `url(${require('../../../Component/Images/backroundimg.png')})` }}>
      <div className="blog-header-content">
        <h1 className="blog-title-header">Explore Our Latest Blog</h1>
        <p className="blog-description">
        Discover expert insights, industry trends, and cutting-edge innovations in the IT world. From software development to AI and cybersecurity, our blogs keep you ahead in the digital era.
        </p>
      </div>
    </div>
  );
};

export default Header;